module.exports = __webpack_public_path__ + "static/media/about_card.2b3c56bd.jpg";